import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { takeLatest, put, call } from "redux-saga/effects";
import { ShowError, ShowSucess } from "../../_helper/helper";
import { getFormalApiErrorMessage } from "../../utils/apiError";

import {
  GET_LOOKUP_POSITIONS,
  GET_POSITIONS,
  GET_POSITIONS_DETAILS,
  POSITION_CREATE,
  POSITION_DELETE,
  POSITION_CREATE_JOB,
  POSITION_UPDATE,
    GET_JOB_POSITIONS,
  JOB_POSITION_CREATE,
  JOB_POSITION_CREATE_SUCCESS,
  JOB_POSITION_CREATE_FAIL,
  JOB_POSITION_UPDATE,
  JOB_POSITION_UPDATE_SUCCESS,
  JOB_POSITION_UPDATE_FAIL,
  JOB_POSITION_DELETE,
  JOB_POSITION_DELETE_SUCCESS,
  JOB_POSITION_DELETE_FAIL,
} from "./actionTypes";

import {
  getPositionsSuccess,
  getPositionsFail,
  getPositionsDetailsSuccess,
  getPositionsDetailsFail,
  createPositionSuccess,
  createPositionFail,
  updatePositionSuccess,
  updatePositionFail,
  deletePositionSuccess,
  deletePositionFail,
  getLookupPositionsSuccess,
  getLookupPositionsFail,
  createPositionJobSuccess,
  createPositionJobFail,
    getJobPositionsSuccess,
  getJobPositionsFail,
  createJobPositionSuccess,
  createJobPositionFail,
  updateJobPositionSuccess,
  updateJobPositionFail,
  deleteJobPositionSuccess,
  deleteJobPositionFail,
} from "./actions";

import {
    getJobPositions,
  createJobPosition,
  updateJobPosition,
  deleteJobPosition,
  createPosition,
  deletePosition,
  getLookupPositions,
  getPositionDetails,
  getPositions,
  updatePosition,
} from "../../_helper/services/position";
function* onGetPositions({ payload: { page, pageSize } }) {
  try {
    const response = yield call(getPositions, { page, pageSize });
    yield put(getPositionsSuccess(response));
  } catch (error) {
    yield put(getPositionsFail(error.response));
  }
}

function* onGetLookupPositions() {
  try {
    const response = yield call(getLookupPositions);
    yield put(getLookupPositionsSuccess(response));
  } catch (error) {
    yield put(getLookupPositionsFail(error.response));
  }
}

function* onGetPositionDetails({ payload: id }) {
  try {
    let response = yield call(getPositionDetails, id);
    response.npositionNo = response?.npositionNo?.trim();
    yield put(getPositionsDetailsSuccess(response));
  } catch (error) {
    yield put(getPositionsDetailsFail(error.response));
  }
}
function* onCreatePosition({ payload }) {
  try {
    const response = yield call(createPosition, payload);
    yield put(createPositionSuccess(response));
    ShowSucess("Position Created Successfully", {
      position: "top-right",
    });
  } catch (error) {
    yield put(createPositionFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}
// function* onCreateJobPosition({ payload }) {
//   try {
//     const response = yield call(createJobPosition, payload);
//     yield put(createPositionJobSuccess(response));
//     console.log("payloadidshow", payload);
//     const isUpdate = !!payload.id;

//     ShowSucess(
//       isUpdate
//         ? "Category Updated Successfully"
//         : "Category Created Successfully",
//       {
//         position: "top-right",
//       }
//     );
//   } catch (error) {
//     yield put(createPositionJobFail(error.response));
//     ShowError(getFormalApiErrorMessage(error));
//   }
// }

function* onUpdatePosition({ payload: { id }, payload }) {
  try {
    const response = yield call(updatePosition, id, payload);
    yield put(updatePositionSuccess(response));
    ShowSucess("Position Details Updated Successfully", {
      position: "top-right",
    });
  } catch (error) {
    yield put(updatePositionFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}
function* onDeletePosition({ payload: ID }) {
  try {
    const response = yield call(deletePosition, ID);
    yield put(deletePositionSuccess(response));
    ShowSucess("Deleted successfully", {
      position: "top-right",
    });
  } catch (error) {
    yield put(deletePositionFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onGetJobPositions({ payload: id }) {
  try {
    const response = yield call(getJobPositions, id);
    // Optional: cleanup/transform, like trimming fields
    response.npositionNo = response?.npositionNo?.trim();
    yield put(getJobPositionsSuccess(response));
  } catch (error) {
    yield put(getJobPositionsFail(error.response));
  }
}


function* onCreateJobPosition({ payload }) {
  try {
    const response = yield call(createJobPosition, payload);
    yield put(createJobPositionSuccess(response));
    ShowSucess("Job Position Created Successfully", {
      position: "top-right",
    });
  } catch (error) {
    yield put(createJobPositionFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onUpdateJobPosition({ payload: { id, ...rest } }) {
  try {
    const response = yield call(updateJobPosition, id, rest);
    yield put(updateJobPositionSuccess(response));
    ShowSucess("Job Position Updated Successfully", {
      position: "top-right",
    });
  } catch (error) {
    yield put(updateJobPositionFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onDeleteJobPosition({ payload }) {
  try {
    const response = yield call(deleteJobPosition, payload);
    yield put(deleteJobPositionSuccess(response));
    ShowSucess("Job Position Deleted Successfully", {
      position: "top-right",
    });
  } catch (error) {
    yield put(deleteJobPositionFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}


function* CartSaga() {
  yield takeLatest(GET_POSITIONS, onGetPositions);
  yield takeLatest(GET_LOOKUP_POSITIONS, onGetLookupPositions);
  yield takeLatest(GET_POSITIONS_DETAILS, onGetPositionDetails);
  yield takeLatest(POSITION_CREATE, onCreatePosition);
  yield takeLatest(POSITION_UPDATE, onUpdatePosition);
  yield takeLatest(POSITION_DELETE, onDeletePosition);
  yield takeLatest(POSITION_CREATE_JOB, onCreateJobPosition);

    yield takeLatest(GET_JOB_POSITIONS, onGetJobPositions);
  yield takeLatest(JOB_POSITION_CREATE, onCreateJobPosition);
  yield takeLatest(JOB_POSITION_UPDATE, onUpdateJobPosition);
  yield takeLatest(JOB_POSITION_DELETE, onDeleteJobPosition);
}

export default CartSaga;
